import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [balance, setBalance] = useState(0);

  const refreshBalance = useCallback(async () => {
    try {
      const { data } = await api.get("/tokens/balance");
      setBalance(data.balance);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const loadUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      refreshBalance();
    } catch (e) {
      setUser(false);
    }
  }, [refreshBalance]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    refreshBalance();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    refreshBalance();
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
    setBalance(0);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, balance, refreshBalance, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
